import {
  claimTicket,
  joinTicket,
  transferEditRights,
} from '@/api/ticketAssignments';
import { useAuth } from '@/providers/AuthProvider';
import { handleAPIError } from '@/utils/errorHandler';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useClaimTicket = (ticketId: string) => {
  const queryClient = useQueryClient();
  const { organization } = useAuth();
  const orgId = organization?.id;

  return useMutation({
    mutationFn: () => claimTicket(ticketId),
    onSuccess: () => {
      // Invalidate this ticket + ticket list
      queryClient.invalidateQueries({ queryKey: ['ticket', orgId, ticketId] });
      queryClient.invalidateQueries({ queryKey: ['tickets', orgId] });
    },
    onError: (error) => handleAPIError(error),
  });
};

export const useJoinTicket = (ticketId: string) => {
  const queryClient = useQueryClient();
  const { organization } = useAuth();
  const orgId = organization?.id;

  return useMutation({
    mutationFn: () => joinTicket(ticketId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ticket', orgId, ticketId] });
      queryClient.invalidateQueries({ queryKey: ['tickets', orgId] });
    },
    onError: (error) => handleAPIError(error),
  });
};

export const useTransferEditRights = (ticketId: string) => {
  const queryClient = useQueryClient();
  const { organization } = useAuth();
  const orgId = organization?.id;

  return useMutation({
    mutationFn: (toUserId: string) => transferEditRights(ticketId, toUserId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ticket', orgId, ticketId] });
    },
    onError: (error) => handleAPIError(error),
  });
};
